import { getShipmentCardsApi } from "./getShipmentCardsApi";

export const getShipmentCardsSetData = async (
  lang,
  setMessageResponse,
  cookies,
  setCardsData,
  userId
) => {
  const response = await getShipmentCardsApi(lang, cookies, userId);
  if (response.success) {
    setCardsData(() => response.res.data.data);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
